import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Card","CardHeader","CardTitle"] */ "/vercel/path1/src/components/ui/card.tsx");
